"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * @author Vahagn Lazyan.
 * @since 2.2.0
 */
var core_1 = require("@angular/core");
var idm_dynamic_controls_metadata_1 = require("@synisys/idm-dynamic-controls-metadata");
var warning_popup_1 = require("./warning-popup");
require("./warning-button.component.scss");
/**
 * Button with warning message popup.
 * By default this is a delete button, so default message keys are in context of deletion.
 * @implements AfterContentInit
 */
var WarningButtonComponent = /** @class */ (function () {
    function WarningButtonComponent() {
        /**
         * Additional classes to pass from outer.
         * @default
         * @type {string}
         */
        this.classes = '';
        /**
         * Title message key for {@link WarningPopupComponent}.
         * @default
         * @type {string}
         */
        this.popupTitleKey = 'de_delete_popup_title';
        /**
         * Warning message key.
         * @default
         * @type {string}
         */
        this.warningMessageKey = 'de_delete_warning';
        /**
         * Button message key.
         * @default
         * @type {string}
         */
        this.buttonMessageKey = 'de_delete';
        this.okActionDone = new core_1.EventEmitter();
        this.noActionDone = new core_1.EventEmitter();
        /**
         * Warning Popup Active Status
         * @type boolean
         */
        this._isWarningPopupActive = false;
    }
    Object.defineProperty(WarningButtonComponent.prototype, "isReady", {
        get: function () {
            return this._isReady;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(WarningButtonComponent.prototype, "isWarningPopupActive", {
        get: function () {
            return this._isWarningPopupActive;
        },
        enumerable: true,
        configurable: true
    });
    WarningButtonComponent.prototype.ngAfterContentInit = function () {
        this._isReady = true;
    };
    WarningButtonComponent.prototype.okAction = function () {
        this.okActionDone.emit();
        this.setWarningPopupActive(false);
    };
    WarningButtonComponent.prototype.noAction = function () {
        this.noActionDone.emit();
        this.setWarningPopupActive(false);
    };
    WarningButtonComponent.prototype.openWarningPopup = function () {
        this.setWarningPopupActive(true);
    };
    WarningButtonComponent.prototype.setWarningPopupActive = function (isWarningPopupActive) {
        if (this.isWarningPopupActive !== isWarningPopupActive) {
            this._isWarningPopupActive = isWarningPopupActive;
            this.warningPopup && isWarningPopupActive && this.warningPopup.openPopup();
            this.warningPopup && (!isWarningPopupActive) && this.warningPopup.closePopup();
        }
    };
    __decorate([
        core_1.Input(),
        __metadata("design:type", String)
    ], WarningButtonComponent.prototype, "id", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], WarningButtonComponent.prototype, "classes", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], WarningButtonComponent.prototype, "popupTitleKey", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], WarningButtonComponent.prototype, "warningMessageKey", void 0);
    __decorate([
        core_1.Input(),
        __metadata("design:type", Object)
    ], WarningButtonComponent.prototype, "buttonMessageKey", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], WarningButtonComponent.prototype, "okActionDone", void 0);
    __decorate([
        core_1.Output(),
        __metadata("design:type", core_1.EventEmitter)
    ], WarningButtonComponent.prototype, "noActionDone", void 0);
    __decorate([
        core_1.ViewChild('warningPopup'),
        __metadata("design:type", warning_popup_1.WarningPopupComponent)
    ], WarningButtonComponent.prototype, "warningPopup", void 0);
    WarningButtonComponent = __decorate([
        core_1.Component({
            moduleId: module.id + '',
            selector: 'sis-warning-button',
            template: require('./warning-button.component.html'),
        }),
        idm_dynamic_controls_metadata_1.ControlMetadata({
            template: "<sis-warning-button\n                                    [id]=\"'%{id}'\"\n                                    [classes]=\"%{class}\"\n                                    (okActionDone)=\"%{okAction}\"\n                                    %{#title_msg} [popupTitleKey]=\"'%{title_msg}'\" %{/title_msg}\n                                    %{#warning_msg} [warningMessageKey]=\"'%{warning_msg}'\" %{/warning_msg}\n                                    %{#button_msg} [buttonMessageKey]=\"'%{button_msg}'\" %{/button_msg}>\n                              </sis-warning-button>",
        })
    ], WarningButtonComponent);
    return WarningButtonComponent;
}());
exports.WarningButtonComponent = WarningButtonComponent;
//# sourceMappingURL=warning-button.component.js.map